/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function NewMessageStatusIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="6" height="7" viewBox="0 0 6 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="3" cy="3.5" r="3" fill="#0F6C30" />
    </svg>
  );
}

export default NewMessageStatusIcon;
